"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CameraMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _Menu = require("./Menu");
var _WebMenuItem = require("./WebMenuItem");
var _Edit = _interopRequireDefault(require("@material-ui/icons/Edit"));
var _Settings = _interopRequireDefault(require("@material-ui/icons/Settings"));
var _Delete = _interopRequireDefault(require("@material-ui/icons/Delete"));
var _DashcamSettings = require("../icons/DashcamSettings");
var _Typography = require("./Typography");
var _pittaModules = require("@thingsw/pitta-modules");
var _Divider = _interopRequireDefault(require("@material-ui/core/Divider"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    icon: {
      display: "block",
      fill: _pittaModules.LightColors.primary["1"]
    },
    delete: {
      color: _pittaModules.LightColors.secondary["11"]
    },
    divider: {
      margin: theme.spacing(1, 0)
    },
    newDiv: {
      backgroundColor: _pittaModules.LightColors.secondary["11"],
      borderRadius: 12,
      width: 43,
      height: 24,
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: 8
    }
  };
});
var CameraMenu = function CameraMenu(_ref) {
  var open = _ref.open,
    camera = _ref.camera,
    hideDivider = _ref.hideDivider,
    anchorRef = _ref.anchorRef,
    placement = _ref.placement,
    menuStrings = _ref.menuStrings,
    onClickAway = _ref.onClickAway,
    onRename = _ref.onRename,
    onSettings = _ref.onSettings,
    onUpdate = _ref.onUpdate,
    onDelete = _ref.onDelete;
  var classes = useStyles();
  return /*#__PURE__*/_react.default.createElement(_Menu.Menu, {
    open: open,
    anchorEl: anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current,
    onClickAway: onClickAway,
    placement: placement,
    modifiers: {
      preventOverflow: {
        enabled: false
      },
      hide: {
        enabled: false
      }
    },
    style: {
      zIndex: 101
    }
  }, onRename !== undefined && /*#__PURE__*/_react.default.createElement(_WebMenuItem.WebMenuItem, {
    disabled: onRename === null,
    startIcon: /*#__PURE__*/_react.default.createElement(_Edit.default, {
      fontSize: "small"
    }),
    onClick: onRename === null ? undefined : onRename
  }, menuStrings.rename), onSettings !== undefined && /*#__PURE__*/_react.default.createElement(_WebMenuItem.WebMenuItem, {
    disabled: onSettings === null,
    startIcon: /*#__PURE__*/_react.default.createElement(_Settings.default, {
      fontSize: "small"
    }),
    onClick: onSettings === null ? undefined : onSettings
  }, menuStrings.settings), onUpdate !== undefined && /*#__PURE__*/_react.default.createElement(_WebMenuItem.WebMenuItem, {
    disabled: onUpdate === null,
    startIcon: /*#__PURE__*/_react.default.createElement(_DashcamSettings.DashcamSettings, {
      className: classes.icon
    }),
    endIcon: camera !== null && camera !== void 0 && camera.newFw ? /*#__PURE__*/_react.default.createElement("div", {
      className: classes.newDiv
    }, /*#__PURE__*/_react.default.createElement(_Typography.Typography, {
      category: "Default",
      variant: "Caption",
      htmlColor: _pittaModules.LightColors.primary["0"]
    }, "NEW")) : undefined,
    onClick: onUpdate === null ? undefined : onUpdate
  }, menuStrings.update), onDelete !== undefined && !hideDivider && /*#__PURE__*/_react.default.createElement(_Divider.default, {
    className: classes.divider
  }), onDelete !== undefined && /*#__PURE__*/_react.default.createElement(_WebMenuItem.WebMenuItem, {
    className: classes.delete,
    disabled: onDelete === null,
    startIcon: /*#__PURE__*/_react.default.createElement(_Delete.default, {
      fontSize: "small",
      htmlColor: _pittaModules.LightColors.secondary["11"]
    }),
    onClick: onDelete === null ? undefined : onDelete
  }, menuStrings.delete));
};
exports.CameraMenu = CameraMenu;